module.exports = __webpack_public_path__ + "static/img/happy_train_logo.ed2cbc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/happy_train_logo.png
// module id = IbB0
// module chunks = 1